import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Lottie from "lottie-react";
import constructor from "./constructor.json";

import FullPageNotice from "../../components/FullPageNotice";

export default function FullPageUnderConstructionNotice(props) {

  return (
    <FullPageNotice imageSrc={null}>
      <Box>
        <Grid container>
          <Grid item xs={12} md={4}>
            <Lottie animationData={constructor} loop={true} />
          </Grid>
          <Grid item xs={12} md={8}>
            <Box sx={{ display: "flex", alignContent: "center", justifyContent: "center", flexDirection: "column", height: "100%" }}>
              <Typography variant="h4">This feature is still in development</Typography>
              <Typography variant="body1" sx={{ fontStyle: "italic" }}>Check back again soon!</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </FullPageNotice>
  );
}
